import React, { useEffect } from 'react';
import './AboutPage.css';

const AboutPage = () => {
    useEffect(() => {
        // Animate elements on mount
        const animateElements = () => {
            const elements = document.querySelectorAll('.animate-line');
            elements.forEach((element, index) => {
                setTimeout(() => {
                    element.classList.add('visible');
                }, 300 + (index * 200));
            });
        };

        animateElements();
    }, []);

    return (
        <div className="about-page">
            <div className="about-content">
                {/* Main About Section */}
                <section className="about-section">
                    <h1 className="animate-line">3D Artist & Creative Technologist</h1>
                    
                    <div className="about-text">
                        <p className="animate-line">
                            I'm Jacob, also known as <a href="https://www.ordos.co.uk" target="_blank" rel="noopener noreferrer" className="about-link">Ordos</a> — a freelance 3D artist and creative technologist working at the intersection of art, technology, and human experience. With a background in computer science and audio design, I bring a technical and creative perspective to every project. My work spans interactive installations, 3D production, real-time experiences, and experimental digital media — often blending visuals, sound, and interactivity to build real time experiences.
                        </p>
                    </div>
                </section>

                {/* Experience Section */}
                <section className="cv-section">
                    <h2 className="animate-line">Experience</h2>
                    <div className="experience-list animate-line">
                        <ul>
                            <li>Cinema 4D</li>
                            <li>Unity</li>
                            <li>Touch Designer</li>
                            <li>Photoshop</li>
                            <li>After Effects</li>
                            <li>Unreal Engine</li>
                            <li>Substance Painter</li>
                            <li>Real-time graphics</li>
                            <li>3D production</li>
                            <li>Immersive storytelling</li>
                        </ul>
                    </div>
                </section>

                {/* Footer */}
                <footer className="about-footer">
                    <p className="animate-line">© <span id="year"></span> Jacob Faulkner All rights reserved.</p>
                    <p className="animate-line">No cookies, no tracking, no bullshit.</p>
                </footer>
            </div>
        </div>
    );
};

export default AboutPage; 